var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeakerIconBrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.933 0.659594C10.847 0.667246 10.7612 0.684946 10.6779 0.713305L5.25 2.56389V9.18621L10.6785 11.0368C11.0116 11.1502 11.3813 11.0956 11.6678 10.8909C11.9538 10.6862 12.125 10.3538 12.125 10.0016V7.18852C12.5827 7.00288 12.9062 6.55555 12.9062 6.0313C12.9062 5.50705 12.5827 5.05971 12.125 4.87407V1.74846C12.125 1.39627 11.9541 1.06387 11.6678 0.859179C11.4529 0.705429 11.1911 0.63664 10.933 0.659594ZM4.3125 2.78484L1.83691 2.97527C0.946602 3.04371 0.25 3.79602 0.25 4.68852V7.06157C0.25 7.93032 0.910786 8.66655 1.76672 8.76812L2.06274 11.4335C2.12618 12.0057 2.60863 12.4375 3.18457 12.4375C3.80676 12.4375 4.3125 11.9312 4.3125 11.309V2.78484Z",
    fill: "#DCA21B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerIconBrown);
export default __webpack_public_path__ + "static/media/speaker-icon-brown.a9bc80701a0924088a70fca6f73fdbf0.svg";
export { ForwardRef as ReactComponent };